import { type AnalyticsPlugin } from 'analytics';
import { type AnalyticsEventModel } from 'shisell';

import { type AnalyticsEvent } from '@automation-suite/shared-clients-analytics-dispatcher';
import { HttpStatusCodes } from '@automation-suite/shared-clients-http';
import { BufferedEmitter } from '@automation-suite/shared-utils-buffered-emitter';
import { queryClient } from '@automation-suite/shared-utils-query-client';
import { eipClient } from '@automation-suite/widget-loader-clients-eip';

const eipBufferedEmitter: BufferedEmitter<AnalyticsEventModel> = new BufferedEmitter<AnalyticsEventModel>({
  action: (events: AnalyticsEventModel[]) => {
    queryClient.fetchQuery({
      queryFn: async () => {
        const response = await eipClient.createAnalyticEvents({
          events: events,
        });

        if (response.status !== HttpStatusCodes.OK) {
          throw new Error('Failed to create analytics event');
        }

        return response;
      },
      queryKey: ['eip-create-analytics-event', events],
      retry: 3,
    });
  },
  emitInterval: 2000,
  maxItems: 10,
});

export const eipPlugin: AnalyticsPlugin = {
  name: 'eip',
  track: (event: AnalyticsEvent) => {
    event.payload.properties.MetaData.DispatchedBy = 'SIN-EIPPlugin';
    eipBufferedEmitter.add(event.payload.properties);
  },
};
